function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import { IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import Search from '@material-ui/icons/Search';
import SearchBar from 'material-ui-search-bar';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/styles';
var typeStyles = {
  container: {
    display: 'flex'
    /* establish flex container */
    ,
    flexGrow: 1,
    flexDirection: 'column'
    /* make main axis vertical */
    ,
    justifyContent: 'center'
    /* center items vertically, in this case */
    ,
    alignItems: 'center'
    /* center items horizontally, in this case */
    ,
    marginTop: '60px'
  },
  item: {
    textAlign: 'center'
  }
};

var tabStyles = function tabStyles(theme) {
  return {
    flex: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      minHeight: 56
    },
    helper: {},
    searchBar: {
      flexGrow: '1',
      paddingRight: 0,
      boxShadow: 'none !important',
      width: '100%',
      height: 'unset'
    },
    searchBarContainer: {
      marginRight: 0,
      paddingRight: 0
    },
    expansionPanelDetails: {
      flexDirection: 'column',
      borderTop: 'solid 1px rgba(0,0,0,0.1)',
      paddingTop: '20px'
    },
    expasionPanelSummary: {
      display: 'flex',
      padding: '0'
    },
    buttonFilter: {},
    buttonFilterExpanded: {
      marginRight: '16px'
    },
    expandIcon: {
      transition: 'none',
      marginRight: '-8px'
    },
    noPaddingRight: {
      paddingRight: '0 !important'
    }
  };
};

export var NoItemsSearchDialog = withStyles(typeStyles)(function (_ref) {
  var classes = _ref.classes,
      _ref$itemPlaceHolder = _ref.itemPlaceHolder,
      itemPlaceHolder = _ref$itemPlaceHolder === void 0 ? 'Nenhum item encontrado com esses critérios.' : _ref$itemPlaceHolder;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.item
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Search, null), " ", itemPlaceHolder)));
});
var style = {
  height: '100%'
};
var style1 = {
  marginLeft: '5px'
};
var useSearchDialogStyles = makeStyles(tabStyles);
export var SearchTextContext = /*#__PURE__*/React.createContext(null);
export var SearchDialog = function SearchDialog(_ref2) {
  var children = _ref2.children,
      label = _ref2.label,
      setMenuIsOpen = _ref2.setMenuIsOpen,
      selectPromptMessage = _ref2.selectPromptMessage;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      textSearch = _useState2[0],
      setTextSearch = _useState2[1];

  var classes = useSearchDialogStyles();

  var onClick = function onClick() {
    return setMenuIsOpen(false);
  };

  return /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: true,
    onClose: onClick,
    open: true,
    disableEscapeKeyDown: true
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(IconButton, {
    style: style1,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(ArrowBackIos, {
    color: "inherit"
  })), /*#__PURE__*/React.createElement(SearchBar, {
    classes: {
      root: [classes.searchBar, classes.noPaddingRight].join(' '),
      searchContainer: classes.searchBarContainer
    },
    placeholder: "".concat(selectPromptMessage, ": ").concat(label, "..."),
    value: textSearch,
    onCancelSearch: function onCancelSearch() {
      return setTextSearch('');
    },
    onChange: function onChange(newValue) {
      return setTextSearch(newValue);
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: style
  }, /*#__PURE__*/React.createElement(SearchTextContext.Provider, {
    value: textSearch
  }, children)));
};